var getAlertTheme = theme => ({
  colors: {
    background: {
      success: theme.colors.greens[5],
      informational: theme.colors.blues[5],
      warning: theme.colors.yellows[5],
      critical: theme.colors.reds[5]
    },
    iconBackground: {
      success: theme.colors.greens[70],
      informational: theme.colors.blues[50],
      warning: theme.colors.oranges[50],
      critical: theme.colors.reds[50]
    },
    border: {
      success: theme.colors.greens[40],
      warning: theme.colors.yellows[50],
      critical: theme.colors.reds[40],
      informational: theme.colors.blues[40]
    },
    link: {
      text: {
        initial: theme.colors.greys[100],
        active: theme.colors.greys[90]
      },
      textDecoration: {
        hover: theme.colors.greys[90],
        active: theme.colors.greys[20],
        initial: theme.colors.greys[40]
      },
      outline: {
        focus: theme.colors.greys[100]
      }
    },
    button: {
      text: {
        initial: theme.colors.greys[80]
      },
      border: {
        initial: "rgba(0, 0, 0, 0.3)"
      },
      background: {
        hover: "rgba(255, 255, 255, 0.3)"
      }
    },
    closeButton: {
      text: {
        initial: theme.colors.greys[50]
      },
      border: {
        initial: "rgba(0, 0, 0, 0.3)"
      },
      background: {
        hover: "rgba(255, 255, 255, 0.3)"
      }
    }
  }
});
export { getAlertTheme };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
